module.exports = __webpack_public_path__ + "media/img/automated-testing/benefits/benefits-img5-fc51bef83a1a8987d93653c0c54650a2.svg";